var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
export var SelectedObjectUtils;
(function (SelectedObjectUtils) {
    function selectedNodesAsDict(store) {
        return store
            .selectSnapshot(EngineNodesState.getCheckedNodeIds)
            .reduce(function (acc, id) {
            acc[id] = true;
            return acc;
        }, {});
    }
    SelectedObjectUtils.selectedNodesAsDict = selectedNodesAsDict;
    // EngineNodeState isn't the definitive source of truth of selected objects.
    // If a successor node is checked, it's leaves won't be.
    // We must check its leaves manually.
    function isObjectSelected(objectId, selectedNodes, viewGraph, graphService) {
        var e_1, _a;
        // If an object is in the store of checked nodes, great!
        if (selectedNodes[objectId]) {
            return true;
        }
        // If not, check to see if the object is one of its leaves!
        var selectedIds = Object.keys(selectedNodes);
        try {
            for (var selectedIds_1 = __values(selectedIds), selectedIds_1_1 = selectedIds_1.next(); !selectedIds_1_1.done; selectedIds_1_1 = selectedIds_1.next()) {
                var id = selectedIds_1_1.value;
                if (graphService.getLeafDescendants(viewGraph, id).includes(objectId)) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (selectedIds_1_1 && !selectedIds_1_1.done && (_a = selectedIds_1.return)) _a.call(selectedIds_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    }
    SelectedObjectUtils.isObjectSelected = isObjectSelected;
})(SelectedObjectUtils || (SelectedObjectUtils = {}));
